import type {
  DragEndProps,
  DragMoveProps,
  DragStartProps,
  PointerEventModifiers,
  PointerEventPosition,
} from '../../../types/pointer-events.js';
import type { InteractionMode, Interactions } from '../types.js';
import { getActiveMode } from './get-active-mode.js';

export const getInterfaceInteractions = (
  interactions: Interactions,
  mode: InteractionMode,
  isZoomDisabled?: boolean,
  isZoomXDisabled?: boolean,
  isPanDisabled?: boolean,
) => ({
  onDragStart: (event: DragStartProps & PointerEventModifiers) =>
    interactions[getActiveMode(mode, event, isZoomXDisabled)].onDragStart(
      event,
    ),
  onDragMove: (event: DragMoveProps & PointerEventModifiers) =>
    interactions[getActiveMode(mode, event, isZoomXDisabled)].onDragMove(event),
  onDragEnd: (event: DragEndProps & PointerEventModifiers) =>
    interactions[getActiveMode(mode, event, isZoomXDisabled)].onDragEnd(event),
  onDragStartWithMiddleButton: () =>
    interactions[getActiveMode(mode)].onDragStartWithMiddleButton(),
  onDragMoveWithMiddleButton: (event: DragMoveProps & PointerEventModifiers) =>
    interactions[
      getActiveMode(mode, event, isZoomXDisabled)
    ].onDragMoveWithMiddleButton(event),
  onDragEndWithMiddleButton: (event: DragEndProps & PointerEventModifiers) =>
    interactions[
      getActiveMode(mode, event, isZoomXDisabled)
    ].onDragEndWithMiddleButton(event),
  onTap: (event: PointerEventPosition & PointerEventModifiers) =>
    interactions[getActiveMode(mode, event)].onMouseClickOrTap(event),
  onDoubleTap: () =>
    interactions[getActiveMode(mode)].onDoubleClickOrTap('pointer'),
  onMouseClick: (event: PointerEventPosition & PointerEventModifiers) =>
    interactions[getActiveMode(mode, event, isZoomDisabled)].onMouseClickOrTap(
      event,
    ),
  onMouseDoubleClick: () =>
    interactions[getActiveMode(mode)].onDoubleClickOrTap('pointer'),
  onMouseHover: (event: PointerEventPosition & PointerEventModifiers) =>
    interactions[
      getActiveMode(mode, event, isZoomXDisabled, isPanDisabled)
    ].onMouseHover(event),
});
